<main class="flex-1 overflow-auto contain-area pb-safe">
  <div class="network-container">
    <h2 class="network-heading">No Network Found</h2>
    <p>Please check your internet connection and try again.</p>
    <ion-button [mode]="'ios'" type="button" shape="round" color="primary" fill="outline">Try again</ion-button>
  </div>
</main>
